import { staffRoles } from "../../../utils/constants";

function Role({ staff, role, handleRoleSelect }) {
    const isChecked = staff?.roles.some(item => item.roleId === role?.roleId);

    return (
        <div>
            <input
                type="checkbox"
                id={role?.name}
                name="roles"
                value={role?.roleId}
                className="hidden peer"
                onChange={handleRoleSelect}
                checked={isChecked}
            />
            <label
                htmlFor={role?.name}
                className="flex items-center justify-center px-4 py-2.5 w-full text-sm font-medium rounded-lg border cursor-pointer transition-colors select-none
                    text-gray-600 bg-white border-gray-200 hover:border-gray-300 hover:bg-gray-50
                    peer-checked:bg-[#1e3a6e] peer-checked:text-white peer-checked:border-[#1e3a6e]"
            >
                {staffRoles(role?.name)}
            </label>
        </div>
    );
}

export default Role;
